import globalState from './global/state.js';
import globalMutations from './global/mutations.js';
import globalGetters from './global/getters.js';
import globalActions from './global/actions.js';
import checkoutStore from './modules/checkout/checkoutStore.js';
import productsListPageStore from './modules/productsListPage/productsListPageStore.js';
import productPageStore from './modules/productPage/productPageStore.js';
import cartPageStore from './modules/cartPage/cartPageStore.js';

const store = {
  state: globalState,
  mutations: globalMutations,
  actions: globalActions,
  getters: globalGetters,
  modules: {
    checkout: checkoutStore,
    productsListPage: productsListPageStore,
    productPage: productPageStore,
    cartPage: cartPageStore
  }
};

export default store;
